import { TemplateModel } from '@/components/ui';

import {
  countryCodeFormatter,
  dateFormatter,
  genderFormatter,
  highConfidenceValidator,
  numericFormatter,
} from './common.ts';

export const ID_CARD: TemplateModel = {
  fields: [
    {
      id: 'last_name',
      type: 'single-value',
      name: 'Last Name',
      promptHint: 'Last name of the person. Can appear as surname or family name.',
      validators: [highConfidenceValidator],
    },
    {
      id: 'first_name',
      type: 'single-value',
      name: 'First Name',
      promptHint: 'First name of the person. Can appear as given name(s).',
      validators: [highConfidenceValidator],
    },
    {
      id: 'gender',
      type: 'single-value',
      name: 'Gender',
      promptHint: "The person's gender",
      formatters: [genderFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'document_number',
      type: 'single-value',
      name: 'Document Number',
      promptHint: 'ID of the document, such as a passport number or ID card number.',
      validators: [highConfidenceValidator],
    },
    {
      id: 'date_of_expiry',
      type: 'single-value',
      name: 'Date Of Expiry',
      promptHint: 'Return ISO formatted date of expiry.',
      formatters: [dateFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'nationality',
      type: 'single-value',
      name: 'Nationality',
      promptHint: 'ISO formatted nationality.',
      formatters: [countryCodeFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'height',
      type: 'single-value',
      name: 'Height',
      promptHint: 'Height of the person, without units',
      formatters: [numericFormatter],
      validators: [highConfidenceValidator],
    },
  ],
  sampleDocuments: ['https://public.cradl.ai/sample_documents/ID_Card.pdf'],
};
